import React, { memo, useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { currentActionSelector } from 'store/user/selectors'
import { startMachine, stopMachine } from 'store/production'
import { productDevelopedSelector } from 'store/productDevelopment/selectors'
import { MACHINE_STATES } from 'constants/machines'
import { ACTIONS_STATES_LIST } from 'constants/teamStates'
import ActionButton from 'components/Shared/ActionButton'

function MachineStartButton({ machineId, productType, status }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [selected, setSelected] = useState(false)

  const currentAction = useSelector(currentActionSelector)
  const isDeveloped = useSelector(productDevelopedSelector(productType))

  const withStartButton = useMemo(
    () =>
      currentAction === ACTIONS_STATES_LIST.waiting_start_new_production &&
      status === MACHINE_STATES.installed &&
      isDeveloped,
    [currentAction, isDeveloped, status]
  )

  const handleOnClick = useCallback(() => {
    if (selected) {
      dispatch(stopMachine(machineId))
    } else {
      dispatch(startMachine(machineId))
    }

    setSelected((old) => !old)
  }, [selected, machineId])

  const buttonVariant = useMemo(() => (selected ? 'negative' : 'positive'), [selected])
  const buttonText = useMemo(
    () => (selected ? t('machine.cancel') : t('machine.start')),
    [selected]
  )

  if (withStartButton) {
    return (
      <ActionButton
        className="machine__status-button"
        handleOnClick={handleOnClick}
        variant={buttonVariant}
      >
        <div>{buttonText}</div>
      </ActionButton>
    )
  }

  return null
}

MachineStartButton.propTypes = {
  machineId: PropTypes.number.isRequired,
  productType: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired
}

export default memo(MachineStartButton)
